// Auto-generated at build time — do not edit
const APP_VERSION = '2026.11.03.2136';
export default APP_VERSION;
